import React from 'react';
import { Navigate } from 'react-router';
import { useLanguage } from '../hooks/use-language';

export const LanguageRedirect: React.FC = () => {
  const currentLanguage = useLanguage();
  return <Navigate replace to={`/${currentLanguage}`} />;
};
